import * as types from './action-types';

const initialState = {
  fetchingVehicles: false,
  fetchingVehicleDetails: false,
  vehicles: [],
  vehicleDetails: {},
  totalVehicles: 0,
  currentPage: 0,
  avaiableCostCenter: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FETCHING_VEHICLES:
      return Object.assign({}, state, {
        fetchingVehicles: true,
      });
    case types.FETCH_VEHICLES_SUCCESS:
      return Object.assign({}, state, {
        fetchingVehicles: false,
        vehicles: action.data.Details,
        totalVehicles: action.data.Total,
        currentPage: 1,
      });
    case `${types.FETCH_VEHICLE_DETAILS}_PENDING`:
      return Object.assign({}, state, {
        fetchingVehicleDetails: true,
        vehicleDetails: {},
      });
    case `${types.FETCH_VEHICLE_DETAILS}_FULFILLED`:
      return Object.assign({}, state, {
        fetchingVehicleDetails: false,
        vehicleDetails: action.payload.data,
      });
    case types.ADD_MORE_VEHICLES_SUCCESS:
      return Object.assign({}, state, {
        fetchingVehicles: false,
        vehicles: [...state.vehicles, ...action.data.Details],
        totalVehicles: action.data.Total,
        currentPage: state.currentPage + 1,
      });
    case `${types.FETCH_VEHICLE_COSTCENTERLIST}_PENDING`:
      return Object.assign({}, state, {
        fetchingVehicleDetails: true,
      });
    case `${types.FETCH_VEHICLE_COSTCENTERLIST}_FULFILLED`:
      const avaiableCostCenter = Object.assign({}, action.payload.data);
      if (action.payload.offset !== 0) {
        avaiableCostCenter.companyHierarchy = [
          ...state.avaiableCostCenter.companyHierarchy,
          ...action.payload.data.companyHierarchy,
        ];
      }
      return Object.assign({}, state, {
        fetchingVehicleDetails: false,
        avaiableCostCenter,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/features/relocations/vehicle/reducer.js